import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action } from 'mobx';
import Modal from '../Modal';
import Spinner from '../Spinner';
import Form, { FormBody, FormActions, TextInput, SelectInput } from '../Form';
import ReactDropzone from 'react-dropzone';
import request from 'superagent';
import {token} from '../../libs/localStorage';
import { BASE_URL } from "../../config";
import CronIntervalInput from "../CronIntervalInput";

@inject('daqProcessorStore', 'dataSourceStore', 'daqLocationStore')
@observer
class DaqProcessorAdd extends Component {
  static contextTypes = {
    notify: PropTypes.shape().isRequired,
    router: PropTypes.shape().isRequired,
  };

  static propTypes = {
    route: PropTypes.shape().isRequired,
  };

  slug;
  title = 'Add DAQ Processor';
  // locationKeys = {
  //   'source_location': 'Source Location',
  //   'destination_location': 'Destination Location',
  //   'user_name': 'User Name',
  //   'user_password': 'User Password',
  //   'interval': 'Interval',
  //   'mqtt_topic': 'MQTT Topic',
  //   'certificate': 'Certificate',
  // }

  locationKeys = {
    '1': {},
    '3': {
      'source_location': 'Source Location',
      'destination_location': 'Destination Location',
      'user_name': 'User Name',
      'user_password': 'User Password',
      'interval': 'Interval',
    },
    '4': {
      'source_location': 'Source Location',
      'destination_location': 'Destination Location',
      'interval': 'Interval',
    },
    '5': {
      'user_name': 'User Name',
      'user_password': 'User Password',
      'mqtt_topic': 'MQTT Topic',
      'source_location': 'Client ID',
    },
    '6': {
      'user_name': 'User Name',
      'user_password': 'User Password',
      'mqtt_topic': 'Database Name',
      'source_location': 'Source Table',
      'destination_location': 'Destination Table',
      'interval': 'Interval',
    },
    '7': {
      'source_location': 'Source Table',
      'interval': 'Interval',
    }
  };

  @observable daqProcessor = {
    protocol: '',
    // data_source_id: '',
    parser: '',
    aes_key: '',
    // location_id: '',
    address: '',
    port_no: '',
    location: {
      source_location: '',
      destination_location: '',
      user_name: '',
      user_password: '',
      interval: '',
      mqtt_topic: '',
      certificate: '',
    }
  };

  @observable file = null;

  componentWillMount() {
    const { params: { id, daqProcessorId }, daqProcessorStore } = this.props;
    // this.daqProcessor.data_source_id = id;
    this.slug = `/daq/daq-processor`;
  }

  @action onChangeParser = e => this.daqProcessor.parser = e.target.value;
  // @action onChangeDataSource = e => this.daqProcessor.data_source_id = e.target.value;
  @action onChangeProtocol = e => this.daqProcessor.protocol = e.target.value;
  @action onChangeAesKey = e => this.daqProcessor.aes_key = e.target.value;
  @action onChangeLocation = e => this.daqProcessor.location_id = e.target.value;
  @action onChangePortNo = e => this.daqProcessor.port_no = e.target.value;
  @action onChangeAddress = e => this.daqProcessor.address = e.target.value;
  @action onChangeLocationItem = (e, key) => this.daqProcessor.location[key] = e.target.value;

  /*  @action handleSave = (e) => {
      e.preventDefault();

      const { notify } = this.context;
      const { daqProcessorStore } = this.props;
      daqProcessorStore
        .createItem(this.daqProcessor)
        .then(() => {
          this.context.router.push(this.slug);
          notify.success({ message: 'Created DAQ Processor' });
        })
        .catch(action((err) => { notify.error(err); }));
    };  */

  handleSave = e => {
    e.preventDefault();

    const { notify, router } = this.context;
    const { daqProcessorStore } = this.props;
    const url = `${BASE_URL}/daq/daq-processor`;

    const req = request.post(url).set('Authorization', `Bearer ${token.getEncoded()}`);

    req.field('data', JSON.stringify(this.daqProcessor)).attach('parser', this.file);

    req.end((err, res) => {
      if (err) {
        console.log(err);
        notify.error(err);
      } else {
        daqProcessorStore.fetchItems();
        notify.success('Saved.');
        router.push(this.slug);
      }

    })

  };

  onDrop = (files) => {
    this.file = files[0];
  };

  onOpenAddFile = (e) => {
    e.preventDefault();
    this.refs.dropzone.open();
  };

  render() {
    const { params: { id }, daqProcessorStore} = this.props;

    if (daqProcessorStore.isLoading) return <Spinner />;

    return (
      <Modal title={this.title} slug={this.slug} isSaving={daqProcessorStore.isSaving} handleSave={this.handleSave}>
        {/*<ReactDropzone ref="dropzone" onDrop={this.onDrop} style={{ display: 'none' }}>*/}
        {/*<div>Try dropping a file here, or click to select a file to upload.</div>*/}
        {/*</ReactDropzone>*/}
        <Form>
          <FormBody>
            {/*<SelectInput*/}
            {/*label={'Data Source'}*/}
            {/*value={this.daqProcessor.data_source_id}*/}
            {/*options={dataSourceStore.items}*/}
            {/*fields={{ label: 'name', value: 'id' }}*/}
            {/*onChange={this.onChangeDataSource}*/}
            {/*/>*/}
            {/* <TextInput
              label={'Protocol'}
              value={this.daqProcessor.protocol}
              onChange={this.onChangeProtocol}
            /> */}
            <SelectInput
              label={'Protocol'}
              value={this.daqProcessor.protocol}
              options={daqProcessorStore.protocolOptions}
              fields={{ label: 'name', value: 'id' }}
              onChange={this.onChangeProtocol}
            />
            {/*<TextInput*/}
            {/*label={'Parser'}*/}
            {/*value={this.daqProcessor.parser}*/}
            {/*onChange={this.onChangeParser}*/}
            {/*/>*/}
            <div className='formInput flex flex-row full-width'>
              <label>Parser</label>
              {/*<button onClick={this.onOpenAddFile}>{!!this.file ? this.file.name :"Choose file"}</button>*/}
              <ReactDropzone ref="dropzone"
                             onDrop={this.onDrop}
                             style={{
                               display: "flex",
                               flexDirection: 'column',
                               justifyContent: 'center',
                               textAlign: "center",
                               height: "35px",
                               minWidth: "320px",
                               cursor: "pointer",
                               border: '1px solid lightgrey'
                             }}>
                <span style={{ display: "block", color: '#5d5d5d' }} id={"filename"}>
                  {!!this.file ? this.file.name : 'Click or drag a file here to upload!'}
                </span>
              </ReactDropzone>
            </div>
            <TextInput
              label={'AES Key'}
              value={this.daqProcessor.aes_key}
              onChange={this.onChangeAesKey}
            />
            {/*<SelectInput*/}
            {/*label={'Location'}*/}
            {/*value={this.daqProcessor.location_id}*/}
            {/*onChange={this.onChangeLocation}*/}
            {/*options={daqLocationStore.items}*/}
            {/*fields={{ label: 'source_location', value: 'id' }}*/}
            {/*/>*/}
            <TextInput
              label={'Address'}
              value={this.daqProcessor.address}
              onChange={this.onChangeAddress}
            />
            <TextInput
              label={'Port No.'}
              value={this.daqProcessor.port_no}
              onChange={this.onChangePortNo}
            />
          </FormBody>

          <hr/>
          <FormBody>
            {this.daqProcessor.protocol && Object.keys(this.locationKeys[this.daqProcessor.protocol]).map(key => {
              let InputComponent = key === 'interval' ? CronIntervalInput : TextInput;
              return (
                <InputComponent type={key === 'user_password' ? 'password' : 'text'} value={this.daqProcessor.location && this.daqProcessor.location[key]}
                                label={this.locationKeys[this.daqProcessor.protocol][key]} onChange={e => this.onChangeLocationItem(e, key)}
                                key={`daq-processor-location-edit-item-key-${key}`}/>
              )
            })}
          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );

  }
}

export default DaqProcessorAdd;



// WEBPACK FOOTER //
// ./src/components/DataSource/DaqProcessorAdd.js